import { useMutation, FetchResult } from "@apollo/client";

import {
  CREATE_PROPOSALS,
  SEND_PROPOSAL_STEP,
  UPDATE_PROPOSAL_STEP,
} from "./signUp.mutations";

export const useCreateProposal = (): {
  createProposal: (options?: any) => Promise<FetchResult>;
  loading: boolean;
} => {
  const [createProposal, { loading }] = useMutation(CREATE_PROPOSALS);
  return { createProposal, loading };
};

export const useSendStepProposal = (): {
  sendStepProposal: (options?: any) => Promise<FetchResult>;
  loading: boolean;
} => {
  const [sendStepProposal, { loading }] = useMutation(SEND_PROPOSAL_STEP);
  return { sendStepProposal, loading };
};

export const useUpdateStepProposal = (): {
  updateStepProposal: (options?: any) => Promise<FetchResult>;
  loading: boolean;
} => {
  const [updateStepProposal, { loading }] = useMutation(UPDATE_PROPOSAL_STEP);
  return { updateStepProposal, loading };
};

interface ManipulateStepProposalProps {
  variables: {
    proposal_id?: string;
    step?: string;
    birthdate?: string;
    area_code?: string;
    cell_phone_number?: string;
    token?: string;
    username?: string;
    password?: string;
    answer_quiz?: any;
  };
  type: "send" | "update";
}

interface UseStepProposalReturn {
  manipulateStepProposal: (options: ManipulateStepProposalProps) => any;
  loading: boolean;
}

export const useManipulateStepProposal = (): UseStepProposalReturn => {
  const { sendStepProposal, loading: loadingSendStepProposal } =
    useSendStepProposal();
  const { updateStepProposal, loading: loadingUpdateStepProposal } =
    useUpdateStepProposal();

  async function manipulateStepProposal({
    variables,
    type = "send",
  }: ManipulateStepProposalProps) {
    try {
      if (type === "send") {
        const response = await sendStepProposal({ variables });
        return response?.data?.SendProposalStep;
      }

      if (type === "update") {
        const response = await updateStepProposal({ variables });
        return response?.data?.UpdateProposalStep;
      }
    } catch (error: any) {
      console.log({ ...error });
      return error;
    }
  }

  return {
    manipulateStepProposal,
    loading: loadingSendStepProposal || loadingUpdateStepProposal,
  };
};
